import { FetchResult, MaybeMasked } from '@apollo/client'
import { client } from '../../..'
import { Country, PyramidForecastInput, SavePyramidForecastMutation, SavePyramidForecastMutationVariables } from '../../../types'
import { SAVE_PYRAMID_FORECAST } from '../Mutations'
import { PYRAMID_FORECAST_SELECTOR, PYRAMID_FORECAST_VALUES, PYRAMID_FORECAST_WITH_FILTERS } from '../Queries'

export const savePyramidForecast = async (
  companyId: string,
  country: Country,
  pyramidForecasts: PyramidForecastInput[],
  year: number,
  month: number,
): Promise<FetchResult<MaybeMasked<SavePyramidForecastMutation>>> => {
  const variables = {
    companyId,
    pyramidForecasts,
  }

  const refetchQueryVariables = {
    companyId,
    country,
  }

  return await client.mutate<SavePyramidForecastMutation, SavePyramidForecastMutationVariables>({
    mutation: SAVE_PYRAMID_FORECAST,
    variables,
    errorPolicy: 'all',
    refetchQueries: [
      { query: PYRAMID_FORECAST_WITH_FILTERS, variables: refetchQueryVariables },
      { query: PYRAMID_FORECAST_SELECTOR, variables: refetchQueryVariables },
      { query: PYRAMID_FORECAST_VALUES, variables: { ...refetchQueryVariables, year, month } },
    ],
  })
}
